import { render, staticRenderFns } from "./DirectSkippedSettlementDetail.vue?vue&type=template&id=deea57bc"
import script from "./DirectSkippedSettlementDetail.vue?vue&type=script&lang=js"
export * from "./DirectSkippedSettlementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports